import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environment/environment';
import { BaseApiService } from 'app/shared/services';
import { ApiResponse, PaginatedData } from 'app/shared/types';

import { CONTROLLERS } from './controllers';
import { GetDriverDockGroupResponse } from '../types/driver-dock-group/driver-dock-group';
import { UpdateDriverDockGroupRequest } from '../types/driver-dock-group/update-driver-dock-group';
import { CreateDriverDockGroupRequest } from '../types/driver-dock-group/create-driver-dock-group-request';
import { DeleteDriverDockGroupRequest } from '../types/driver-dock-group/delete-driver-dock-group';

@Injectable({
  providedIn: 'root',
})
export class DriverDockGroupsApiService extends BaseApiService<
  ApiResponse<PaginatedData<GetDriverDockGroupResponse[]>>,
  ApiResponse<PaginatedData<GetDriverDockGroupResponse[]>>,
  GetDriverDockGroupResponse
> {
  constructor(public override http: HttpClient) {
    super(http, environment.yardOpsApiBaseUrl);
  }

  public getDriverDockGroups(): Observable<GetDriverDockGroupResponse[]> {
    const url = `${this.api}/${CONTROLLERS.driverDockGroups}`;
    return this.http.get<ApiResponse<GetDriverDockGroupResponse[]>>(url).pipe(map((response) => response.value));
  }

  public updateDriverDockGroup(request: UpdateDriverDockGroupRequest): Observable<number> {
    const url = `${this.api}/${CONTROLLERS.driverDockGroups}/${request.id}`;
    return this.http
      .patch<ApiResponse<number>>(url, { dockGroupId: request.dockGroupId })
      .pipe(map((response) => response.value));
  }

  public createDriverDockGroup(request: CreateDriverDockGroupRequest): Observable<number> {
    const url = `${this.api}/${CONTROLLERS.driverDockGroups}`;
    return this.http
      .post<ApiResponse<number>>(url, {
        driverId: request.driverId,
        dockGroupId: request.dockGroupId,
      })
      .pipe(map((response) => response.value));
  }

  public deleteDriverDockGroup(request: DeleteDriverDockGroupRequest): Observable<null> {
    const url = `${this.api}/${CONTROLLERS.driverDockGroups}/${request.id}`;
    return this.http.delete<null>(url);
  }

  public override controllerName(): string {
    return CONTROLLERS.driverDockGroups;
  }
}
